import React from 'react';
import './style.css';
import Onboarding from "../components/StoreInfo/Onboarding";

const OnboardingPage = () => (
    <div
        className="mx-auto flex justify-center items-center md:page md:pt-[90px] mp-8 md:pb-[50px] animate-fadeIn">
        <Onboarding/>
    </div>
);

export default OnboardingPage;